import api from './api';

import type {

  CabMeeting,

  CabScheduleEntry,

  CabMeetingListParams,

  SaveScheduleEntryPayload,

  ScheduleEntryListParams,

  UpdateScheduleEntryPayload,

} from '../types/cabSchedule';



export async function fetchScheduleEntries(

  params: ScheduleEntryListParams

): Promise<{ items: CabScheduleEntry[]; total: number }> {

  const response = await api.get<{ items: CabScheduleEntry[]; total: number }>(

    `/cab-definitions/${params.cabDefinitionId}/schedule-entries`,

    {

      params: {

        page: params.page,

        pageSize: params.pageSize,

        search: params.search,

        repeats: params.repeats,

        active: params.active,

      },

    }

  );

  return response.data;

}



export async function getScheduleEntryById(

  cabDefinitionId: string,

  entryId: string

): Promise<CabScheduleEntry | null> {

  try {

    const response = await api.get<CabScheduleEntry>(

      `/cab-definitions/${cabDefinitionId}/schedule-entries/${entryId}`

    );

    return response.data;

  } catch (err: unknown) {

    const status = (err as { response?: { status?: number } })?.response?.status;

    if (status === 404) return null;

    throw err;

  }

}



export async function fetchCabMeetings(

  params: CabMeetingListParams

): Promise<{ items: CabMeeting[]; total: number }> {

  const response = await api.get<{ items: CabMeeting[]; total: number }>(

    `/cab-definitions/${params.cabDefinitionId}/meetings`,

    {

      params: {

        page: params.page,

        pageSize: params.pageSize,

        search: params.search,

        status: params.status,

      },

    }

  );

  return response.data;

}



export async function saveScheduleEntry(
  payload: SaveScheduleEntryPayload
): Promise<{
  entry: CabScheduleEntry;
  meetings: CabMeeting[];
  invitation?: {
    calendarCreated: number;
    calendarFailed: number;
    emailsSent: number;
    emailsFailed: number;
    emailsSkipped?: number;
    warnings: string[];
  };
}> {
  const response = await api.post(
    `/cab-definitions/${payload.cabDefinitionId}/schedule-entries`,
    {
      name: payload.name,
      startDateTime: payload.startDateTime,
      endDateTime: payload.endDateTime,
      allDay: payload.allDay,
      repeats: payload.repeats,
      repeatsUntil: payload.repeatsUntil,
      active: payload.active,
    }
  );
  return response.data;
}

export async function updateScheduleEntry(
  payload: UpdateScheduleEntryPayload
): Promise<{
  entry: CabScheduleEntry;
  meetings: CabMeeting[];
  invitation?: {
    calendarCreated: number;
    calendarFailed: number;
    emailsSent: number;
    emailsFailed: number;
    emailsSkipped?: number;
    warnings: string[];
  };
}> {
  const { cabDefinitionId, entryId, ...body } = payload;
  const response = await api.put(
    `/cab-definitions/${cabDefinitionId}/schedule-entries/${entryId}`,
    body
  );
  return response.data;
}


